var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return this.$store.state.config["locales"].length > 1
    ? _c(
        "section",
        { staticClass: "buttons has-addons", attrs: { id: "languageswitch" } },
        _vm._l(this.$store.state.config["locales"], function (lang) {
          return _c(
            "button",
            {
              key: lang,
              staticClass: "button is-dark has-background-black-bis",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.setLanguage(lang)
                },
              },
            },
            [_c("span", [_vm._v(_vm._s(lang))])]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }